export class ScopePatternFilterRequest {
    // searchTermMap?: Map<string,any[]>;
    seriesFilterList?: any[];
    signalsFilterList?: any[];
    mainGroup?: string;
}